import { Link, useLocation } from "react-router-dom";
import { useLang, useT, LANG_KEY } from "@/i18n/LangContext";

export default function LangSwitch({ onSwitch, dark = false }) {
  const lang = useLang();
  const t = useT();
  const { pathname } = useLocation();

  const targetPath = (l) => {
    if (l === "fi") return pathname === "/privacy" ? "/fi/privacy" : "/fi";
    return pathname === "/fi/privacy" ? "/privacy" : "/";
  };

  return (
    <nav
      aria-label={t.nav.langLabel}
      data-testid="language-toggle"
      className="flex items-center gap-2 text-sm font-medium"
    >
      {["en", "fi"].map((l, i) => (
        <span key={l} className="flex items-center gap-2">
          {i > 0 && (
            <span className={dark ? "text-paper/40" : "text-ink/30"} aria-hidden="true">
              /
            </span>
          )}
          {l === lang ? (
            <span
              aria-current="true"
              className={`underline decoration-bee decoration-2 underline-offset-4 ${
                dark ? "text-paper" : "text-ink"
              }`}
            >
              {l.toUpperCase()}
            </span>
          ) : (
            <Link
              to={targetPath(l)}
              lang={l}
              hrefLang={l}
              data-testid={`lang-switch-${l}`}
              onClick={() => {
                localStorage.setItem(LANG_KEY, l);
                if (onSwitch) onSwitch();
              }}
              className={`transition-colors duration-300 ${
                dark ? "text-paper/60 hover:text-paper" : "text-ink/60 hover:text-ink"
              }`}
            >
              {l.toUpperCase()}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
